<div class="axis-content-wrapper">
  <div class="axis-container-fluid">
    <div class="initial-empty-container">
      <img
        alt=""
        class="axis-img-responsive _mlr-auto"
        src="assets/images/logos/aig-logo-blue.svg"
        loading="lazy"
      />
      <div
        class="axis-title _text-bold"
        role="heading"
        aria-level="1"
      >
        {{ title }}
      </div>
      @if (content) {
        <p>
          {{ content }}
        </p>
      }
       @if (subcontent) {
        <p
          [innerHTML]="subcontent"
        ></p>
      }
      <div
        class="axis-btn-wrapper"
        style="margin-bottom: 1rem"
      >
        <div class="axis-btn-wrapper-center">
          <!-- Both Electronic (AC1) - Show signed download buttons -->
          @if (scenario === "bothElectronic" && showPIP && role == "insured") {
            <button
              axis-button
              class="kind-secondary axis-btn-xs-block"
              [disabled]="downloadPIPInProgress"
              (click)="downloadPIPDocuments()"
            >
              <axis-icon
                icon="download"
                font="custom"
              ></axis-icon>
              <span class="axis-btn-icon-text"> Download PIP Documents </span>
            </button>
            @if (downloadPIPInProgress) {
              <axis-loading
                class="size-small"
                [isInline]="true"
                *ngIf="downloadPIPInProgress"
              ></axis-loading>
            }
          }
          @if ((scenario === "bothElectronic" || scenario === "uimuiOnlyElectronic" || scenario === "uimuiOnlyDeclined") && showUIUM && role == "insured") {
            <button
              axis-button
              class="kind-secondary axis-btn-xs-block"
              [disabled]="downloadUMUIMInProgress"
              (click)="downloadUMUIMDocuments()"
            >
              <axis-icon
                icon="download"
                font="custom"
              ></axis-icon>
              <span class="axis-btn-icon-text"> Download UM/UIM Documents </span>
            </button>
            @if (downloadUMUIMInProgress) {
              <axis-loading
                class="size-small"
                [isInline]="true"
                *ngIf="downloadUMUIMInProgress"
              ></axis-loading>
            }
          }

          <!-- UM/UIM Electronic Only (AC2) - Show signed UM/UIM download button -->
          @if (scenario === "uimuiElectronicPipDeclined" && showUIUM && role == "insured") {
            <button
              axis-button
              class="kind-secondary axis-btn-xs-block"
              [disabled]="downloadUMUIMInProgress"
              (click)="downloadUMUIMDocuments()"
            >
              <axis-icon
                icon="download"
                font="custom"
              ></axis-icon>
              <span class="axis-btn-icon-text"> Download UM/UIM Documents </span>
            </button>
            @if (downloadUMUIMInProgress) {
              <axis-loading
                class="size-small"
                [isInline]="true"
                *ngIf="downloadUMUIMInProgress"
              ></axis-loading>
            }
          }

          <!-- PIP Electronic Only (AC3) - Show signed PIP download button -->
          @if (scenario === "pipElectronicUimuiDeclined" && showPIP && role == "insured") {
            <button
              axis-button
              class="kind-secondary axis-btn-xs-block"
              [disabled]="downloadPIPInProgress"
              (click)="downloadPIPDocuments()"
            >
              <axis-icon
                icon="download"
                font="custom"
              ></axis-icon>
              <span class="axis-btn-icon-text"> Download PIP Documents </span>
            </button>
            @if (downloadPIPInProgress) {
              <axis-loading
                class="size-small"
                [isInline]="true"
                *ngIf="downloadPIPInProgress"
              ></axis-loading>
            }
          }
          <!-- PIP Only Electronic - Show signed PIP download button -->
          @if (scenario === "pipOnlyElectronic" && showPIP && role == "insured") {
            <button
              axis-button
              class="kind-secondary axis-btn-xs-block"
              [disabled]="downloadPIPInProgress"
              (click)="downloadPIPDocuments()"
            >
              <axis-icon
                icon="download"
                font="custom"
              ></axis-icon>
              <span class="axis-btn-icon-text"> Download PIP Documents </span>
            </button>
            @if (downloadPIPInProgress) {
              <axis-loading
                class="size-small"
                [isInline]="true"
                *ngIf="downloadPIPInProgress"
              ></axis-loading>
            }
          }

          <!-- Both Declined (AC4) - No buttons here, handled in non-digital section below -->
        </div>
      </div>
     
      @if (
        isPipNonDigital() ||
        scenario === "uimuiElectronicPipDeclined" ||
        scenario === "pipElectronicUimuiDeclined" ||
        scenario === "bothDeclined" ||
        scenario === "pipOnlyDeclined"
      ) {
        <div class="non-digital-block">
          <!-- PIP Electronic Selection Declined (AC2) -->
          @if (scenario === "uimuiElectronicPipDeclined") {
            <p>{{ uimuiElectronicPipDeclinedContent.nonDigitalContent }}</p>
            <button
              axis-button
              class="kind-secondary axis-btn-xs-block"
              [disabled]="downloadPIPInProgress"
              (click)="downloadUnsignedDocuments('pip')"
            >
              <axis-icon
                icon="download"
                font="custom"
              ></axis-icon>
              <span class="axis-btn-icon-text">Download PIP Documents</span>
            </button>
            @if (downloadPIPInProgress) {
              <axis-loading
                class="size-small"
                [isInline]="true"
              ></axis-loading>
            }
          }

          <!-- UM/UIM Electronic Selection Declined (AC3) -->
          @if (scenario === "pipElectronicUimuiDeclined") {
            <p>{{ pipElectronicUimuiDeclinedContent.nonDigitalContent }}</p>
            <button
              axis-button
              class="kind-secondary axis-btn-xs-block"
              [disabled]="downloadUMUIMInProgress"
              (click)="downloadUnsignedDocuments('uimui')"
            >
              <axis-icon
                icon="download"
                font="custom"
              ></axis-icon>
              <span class="axis-btn-icon-text">Download UM/UIM Documents</span>
            </button>
            @if (downloadUMUIMInProgress) {
              <axis-loading
                class="size-small"
                [isInline]="true"
              ></axis-loading>
            }
          }

          <!-- Both Forms Declined (AC4) -->
          @if (scenario === "bothDeclined") {
            <div class="both-declined-actions">
              <button
                axis-button
                class="kind-secondary axis-btn-xs-block"
                [disabled]="downloadUMUIMInProgress"
                (click)="downloadUnsignedDocuments('uimui')"
              >
                <axis-icon
                  icon="download"
                  font="custom"
                ></axis-icon>
                <span class="axis-btn-icon-text">Download UM/UIM Documents</span>
              </button>
              @if (downloadUMUIMInProgress) {
                <axis-loading
                  class="size-small"
                  [isInline]="true"
                ></axis-loading>
              }

              <button
                axis-button
                class="kind-secondary axis-btn-xs-block"
                [disabled]="downloadPIPInProgress"
                (click)="downloadUnsignedDocuments('pip')"
              >
                <axis-icon
                  icon="download"
                  font="custom"
                ></axis-icon>
                <span class="axis-btn-icon-text">Download PIP Documents</span>
              </button>
              @if (downloadPIPInProgress) {
                <axis-loading
                  class="size-small"
                  [isInline]="true"
                ></axis-loading>
              }
            </div>
          }

          <!-- PIP Only Declined - Show unsigned PIP download button -->
          @if (scenario === "pipOnlyDeclined") {
            <button
              axis-button
              class="kind-secondary axis-btn-xs-block"
              [disabled]="downloadPIPInProgress"
              (click)="downloadUnsignedDocuments('pip')"
            >
              <axis-icon
                icon="download"
                font="custom"
              ></axis-icon>
              <span class="axis-btn-icon-text">Download PIP Documents</span>
            </button>
            @if (downloadPIPInProgress) {
              <axis-loading
                class="size-small"
                [isInline]="true"
              ></axis-loading>
            }
          }
        </div>
      }
      @if (note) {
        <p>
          {{ note }}
        </p>
      }
    </div>
  </div>
</div>
